import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import Carousel from "~/components/carousel/Carousel";
import { Button } from "~/components/ui/button";
import { useMediaQuery } from "~/lib/use-media-query";
import { imageSet } from "~/lib/image-set";
import { imageUrl } from "~/lib/image-url";

// These — and the detail-*.png below — live in media/images/use-cases (plain string
// paths) rather than as JS imports: an imported asset gets pulled into the route's
// dependency graph, which makes the SSR build force-preload it via <link rel="preload">
// even though only one of the three formats is ever actually painted — undoing the point
// of AVIF/WebP by downloading all of them regardless.
const detailFleet = imageUrl("/images/use-cases/detail-fuel-costs.png");
const detailTeen = imageUrl("/images/use-cases/detail-teen.png");
const detailMap = imageUrl("/images/use-cases/detail-mega-map.png");
const detailTuro = imageUrl("/images/use-cases/detail-turo.png");
const detailEv = imageUrl("/images/use-cases/detail-ev.png");

function bgImageSet(base: string) {
  return imageSet(imageUrl(`/images/use-cases/${base}.jpg`));
}

const USE_CASES = [
  { id: "fleet", titleKey: "use_cases.fleet_title", descKey: "use_cases.fleet_desc", bg: `${bgImageSet("background-fuel-costs")} 80% center/cover no-repeat`, featureImg: detailFleet },
  { id: "teen",  titleKey: "use_cases.teen_title",  descKey: "use_cases.teen_desc",  bg: `${bgImageSet("background-teen")} 30% center/cover no-repeat`,       featureImg: detailTeen  },
  { id: "map",   titleKey: "use_cases.map_title",   descKey: "use_cases.map_desc",   bg: `${bgImageSet("background-mega-map")} 30% center/cover no-repeat`,   featureImg: detailMap   },
  { id: "turo",  titleKey: "use_cases.turo_title",  descKey: "use_cases.turo_desc",  bg: `${bgImageSet("background-turo")} 30% center/cover no-repeat`,       featureImg: detailTuro  },
  { id: "ev",    titleKey: "use_cases.ev_title",    descKey: "use_cases.ev_desc",    bg: `${bgImageSet("background-ev")} 40% center/cover no-repeat`,         featureImg: detailEv    },
];

export default function UseCases() {
  const { t } = useTranslation("home");
  const isCompact = useMediaQuery("(max-width: 767px)");

  const items = USE_CASES.map(({ id, titleKey, descKey, bg, ...extra }) => ({
    id,
    title: t(titleKey),
    description: t(descKey),
    cta: t("use_cases.card_cta"),
    seeAll: t("use_cases.read_more"),
    bg,
    ...extra,
  }));

  return (
    <section className="bg-background py-[60px]">
      <div className="wrap mb-10 flex flex-col items-center gap-8">
        <div className="flex flex-col items-center gap-1 text-center">
          <p className="font-display text-text-heading text-xl leading-[110%] font-normal md:text-[48px]">
            <Trans t={t} i18nKey="use_cases.heading_1" />
          </p>
          <p className="font-display text-text-heading text-xl leading-[110%] font-normal md:text-[48px]">
            <Trans t={t} i18nKey="use_cases.heading_2" components={{ bold: <span className="font-bold" /> }} />
          </p>
        </div>
        <Button variant="secondary" size={isCompact ? "sm" : "lg"}>
          {t("use_cases.why_bouncie")}
        </Button>
      </div>

      <Carousel items={items} />

    </section>
  );
}
